import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import styles from "../offlinePay.module.css";
import CommonButton from "../../CommonButton/CommonButton";
import { useMyContext } from "../../../myContext";
import { onBoardOfflinePersonalDetail } from "../../../api";

function OfflineStudentForm({ setStepToShowOffline, stepToShowOffline, studentList, documentUploaded, studentDetail}) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  // const [studentRelationship, setStudentRelationship] = useState("");
  // const [studentRelationshipError, setStudentRelationshipError] = useState("")
  const [nextSectionError, setNextSectionError] = useState("");
  const [loading, setLoading] = useState("");
  const [checkedRemitterStudentBox, setCheckedRemitterStudentForm] =
    useState(false);
  const [valid, setIsValid] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    // studentRelationship: false,
  });
  const { remitterOfflineDetail, setStudentOfflineDetail, setOfflineStudentUserId } = useMyContext();

  // const RelationOption = [
  //   {
  //     label: "Parent",
  //     value: "Parent",
  //   },
  //   {
  //     label: "Sibling",
  //     value: "Sibling",
  //   },
  //   {
  //     label: "Spouse",
  //     value: "Spouse",
  //   },
  //   {
  //     label: "Self",
  //     value: "Self",
  //   },
  // ];

  // const handleChangeOption = (value) => {
  //   setStudentRelationshipError("");
  //   setStudentRelationship(value);
  // };

  useEffect(() => {
    setNextSectionError("")
    if(studentList.length > 0){
      setName(studentDetail?.fullName);
      setEmail(studentDetail?.email);
      let phoneNo = studentDetail?.phone || "";
      const lastTenDigits = phoneNo.length >= 10 ? phoneNo.slice(-10) : phoneNo; 
      setPhoneNumber(Number(lastTenDigits))
      if(studentDetail?.fullName === undefined || studentDetail?.email === undefined || studentDetail?.phone === undefined || studentDetail?.fullName === "" || studentDetail?.email === "" || studentDetail?.phone === ""){
        setNextSectionError("Please contact shreyan@stockal.com. Seems like some details are missing. Please create a new user or contact support.")
      }
    }
  },[studentDetail, studentList])


  useEffect(() => {
    if (checkedRemitterStudentBox) {
      setName(remitterOfflineDetail.name);
      setEmail(remitterOfflineDetail.email);
      setPhoneNumber(remitterOfflineDetail.phone);
    } else {
      setName("");
      setEmail("");
      setPhoneNumber("");
    }
  }, [checkedRemitterStudentBox]);

  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      return false;
    } else {
      return true;
    }
  };

  const handleSuccess = () => {
    if(nextSectionError === ""){
      if(!documentUploaded){
        setStepToShowOffline(4);
      } else{
        setStepToShowOffline(5);
      }
      setStudentOfflineDetail({
        name: name,
        phone: phoneNumber,
        email: email,
        // relation: studentRelationship
      })
    } 
  }

  const studentPersonalDetailApi = () => {
    setLoading(true);
    const remitterPersonalDetailData = async () => {
      const body = {
        name: name,
        email: email,
        phone: "+91" + phoneNumber,
        // relation: studentRelationship,
        accountType: "student",
      };
      try {
        onBoardOfflinePersonalDetail(body).then((resp) => {
          setLoading(false);
          if (resp.status === 200 && resp.data && resp.data.data) {
            handleSuccess();
            setOfflineStudentUserId(resp?.data?.data?.userAccountId);
          } else {
            setNextSectionError(
              resp && resp.data
                ? resp.data.message
                : "something went wrong, please try again later."
            );
          }
        });
      } catch (error) {
        setLoading(false);
        setNextSectionError("something went wrong, please try again later.");
      }
    };
    remitterPersonalDetailData();
  };

  const checkIfValid = () => {
    setNextSectionError("");
    // setStudentRelationshipError("");
    if (name === "") {
      setIsValid({ ...valid, name: true });
    } else if (email === "") {
      setIsValid({ ...valid, email: true });
    } else if (phoneNumber === "") {
      setIsValid({ ...valid, phoneNumber: true });
    }
    // else if (studentRelationship === "") {
    //   setStudentRelationshipError("Please Select Relation");
    // }  
    else if (emailError !== "" || phoneNoError !== ""  
      // || studentRelationshipError !== ""
    ) {
      setNextSectionError("Please fill all the required field correctly.");
    } else {
      // setStudentRelationshipError("");
      setIsValid({
        name: false,
        email: false,
        phoneNumber: false,
        // studentRelationship: false,
      });
      setNextSectionError("");
      studentPersonalDetailApi();
    }
  };

  const handleBlur = (e) => {
    if (e.target.name === "email") {
      if (ValidateEmail() && email !== "") {
        setIsValid({ ...valid, email: true });
        setEmailError("Enter a valid email such as example@email.com");
      } else {
        setEmailError("");
        setIsValid({ ...valid, email: false });
      }
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber !== "" && phoneNumber.length < 10) {
        setIsValid({ ...valid, phoneNumber: true });
        setPhoneNoError("Phone Number should be 10 digit.");
      } else {
        setIsValid({ ...valid, phoneNumber: false });
        setPhoneNoError("");
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value);
    } else if (e.target.name === "email") {
      setEmail(e.target.value);
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber.length === 0 && e.target.value === "0") {
        setPhoneNumber("");
      } else if (e.target.value === "" || e.target.value.length <= 10) {
        setPhoneNumber(e.target.value);
      }
    }
    //  else if (e.target.name == "Relation") {
    //   setStudentRelationship(e.target.value);
    // }
  };

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Personal Detail</Row>
          {stepToShowOffline >= 3 ? (
            <>
              {studentList.length === 0 && <Row>
                <div class="form-check" className={styles.checkMark}>
                  <input
                    class="form-check-input"
                    className={styles.checkbox}
                    type="checkbox"
                    id="flexCheckChecked"
                    checked={checkedRemitterStudentBox}
                    onChange={() => {
                      setCheckedRemitterStudentForm(!checkedRemitterStudentBox);
                    }}
                    disabled={stepToShowOffline !== 3 || studentList.length > 0}
                  />
                  <label
                    class="form-check-label"
                    className={styles.checklabel}
                    for="flexCheckChecked"
                  >
                    Check if the Student Details are the same as the Remitter
                  </label>
                </div>
              </Row>}
              <Row>
                <Col md={4}>
                  <SignInInput
                    name="name"
                    label="Full Name"
                    placeholder="Enter Full Name"
                    type="text"
                    value={name}
                    containerClasses={styles.passwordInvalid}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    isInvalid={valid.name}
                    disabled={stepToShowOffline !== 3 || studentList.length > 0}
                  />
                </Col>
                <Col md={4}>
                  <SignInInput
                    name="email"
                    label="Email ID"
                    placeholder="Enter Email ID"
                    type="text"
                    value={email}
                    containerClasses={styles.passwordInvalid}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    errorMessage={emailError}
                    isInvalid={valid.email}
                    onBlur={(event) => {
                      handleBlur(event);
                    }}
                    disabled={stepToShowOffline !== 3 || studentList.length > 0}
                  />
                </Col>
                <Col md={4}>
                  <SignInInput
                    name="phoneNumber"
                    label="Phone Number"
                    placeholder="Enter Phone Number"
                    type="number"
                    value={phoneNumber}
                    containerClasses={styles.passwordInvalid}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    isInvalid={valid.phoneNumber}
                    onBlur={(event) => {
                      handleBlur(event);
                    }}
                    errorMessage={phoneNoError}
                    showcodediv={true}
                    codedivName={"phone"}
                    disabled={stepToShowOffline !== 3 || studentList.length>0}
                  />
                </Col>
              </Row>
              {/* <Row className="pt-2">
                <Col md={4}>
                  <SignInInput
                    name="PAN"
                    label="PAN Number"
                    placeholder="Enter PAN number"
                    type="text"
                    value={panNumber}
                    containerClasses={styles.passwordInvalid}
                    onChange={(event) => {
                      handleChange(event);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onCopy={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    isInvalid={valid.panNumber}
                    onBlur={(event) => {
                      handleBlur(event);
                    }}
                    errorMessage={panError}
                    disabled={stepToShowOffline !== 3 || studentList.length > 0}
                  />
                </Col>
                <Col md={4}>
                  <Dropdown
                    options={RelationOption}
                    label="Select"
                    heading="Relation with Student"
                    onChange={handleChangeOption}
                  />
                  {studentRelationshipError !== "" && <div className={styles.errorState}>{studentRelationshipError}</div>}
                </Col>
              </Row> */}
              {stepToShowOffline === 3 && <Row className="pt-3 mt-3">
                <div className={styles.errorState}>{nextSectionError}</div>
                {/* <Col md={3}> */}
                <CommonButton
                  title="Next"
                  onClick={studentList.length > 0 ? handleSuccess : checkIfValid}
                  loading={loading}
                  disabled={loading}
                  width={"150px"}
                />
              </Row>}
            </>
          ) : (
            ""
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default OfflineStudentForm;
